import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { HTTPError, objectToQueryString, booleanToString } from './libs';
export var CASClient = /*#__PURE__*/function () {
  function CASClient(config) {
    _classCallCheck(this, CASClient);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "loginExecutionParams", void 0);

    this.config = _Object$assign({}, config, {
      casUrl: config.casUrl.replace(/\/+$/, '')
    });
  }

  _createClass(CASClient, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var endpoint, response, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                endpoint = this.getEndpoint(_Object$assign({
                  path: 'login',
                  serviceUrl: this.config.serviceUrl
                }, params));
                _context.next = 4;
                return fetch(endpoint, CASClient.getRequestOptionsForGET());

              case 4:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context.next = 9;
                return response.json();

              case 9:
                body = _context.sent;

                if (!body.success) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", {
                  success: true,
                  state: body
                });

              case 12:
                return _context.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject(body)
                });

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject()
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 15]]);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getLoginParams",
    value: function () {
      var _getLoginParams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var endpoint, response, body, _obj$username, obj;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                endpoint = this.getEndpoint(_Object$assign({
                  path: 'login',
                  serviceUrl: this.config.serviceUrl
                }, params), true);
                _context2.next = 4;
                return fetch(endpoint, CASClient.getRequestOptionsForGET());

              case 4:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context2.next = 9;
                return response.json();

              case 9:
                body = _context2.sent;

                if (!body.form_defaults) {
                  _context2.next = 14;
                  break;
                }

                obj = body.form_defaults;
                this.loginExecutionParams = {
                  lt: obj.lt,
                  execution: obj.executionKey,
                  _eventId: obj._eventId
                };
                return _context2.abrupt("return", {
                  success: true,
                  state: {
                    username: (_obj$username = obj.username) !== null && _obj$username !== void 0 ? _obj$username : '',
                    rememberUsername: !!obj.rememberUsername,
                    rememberMe: !!obj.keepMeLoggedIn
                  }
                });

              case 14:
                return _context2.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject(body)
                });

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject()
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 17]]);
      }));

      function getLoginParams(_x2) {
        return _getLoginParams.apply(this, arguments);
      }

      return getLoginParams;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
        var username, password, rememberMe, rememberUsername, token, renew, endpoint, response, body;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                username = _ref.username, password = _ref.password, rememberMe = _ref.rememberMe, rememberUsername = _ref.rememberUsername, token = _ref.token, renew = _ref.renew;
                _context3.prev = 1;
                endpoint = this.getEndpoint({
                  path: 'login',
                  serviceUrl: this.config.serviceUrl,
                  renew: renew
                }, true);
                _context3.next = 5;
                return fetch(endpoint, CASClient.createOptionsForPOST({
                  headers: _Object$assign({
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }, token && {
                    'X-Captcha-Token': token
                  }, this.config.isNativeAppDevice && {
                    'X-WH-Native-App': 'true'
                  }, this.config.enableOAuthMode && {
                    'X-OAuth-Flow-Mode': 'true'
                  }),
                  body: objectToQueryString(_Object$assign({
                    username: username,
                    password: password,
                    rememberMe: rememberMe,
                    rememberUsername: rememberUsername,
                    _rememberUsername: booleanToString(rememberUsername),
                    _rememberMe: booleanToString(rememberMe)
                  }, this.loginExecutionParams))
                }));

              case 5:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 8;
                  break;
                }

                throw new HTTPError(response);

              case 8:
                _context3.next = 10;
                return response.json();

              case 10:
                body = _context3.sent;

                if (!body.success) {
                  _context3.next = 13;
                  break;
                }

                return _context3.abrupt("return", {
                  success: true,
                  state: body
                });

              case 13:
                return _context3.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject(body)
                });

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](1);
                return _context3.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject()
                });

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 16]]);
      }));

      function login(_x3) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "loginByToken",
    value: function () {
      var _loginByToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref2) {
        var token, renew, endpoint, response, body;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                token = _ref2.token, renew = _ref2.renew;
                _context4.prev = 1;
                endpoint = this.getEndpoint({
                  path: 'tokenlogin',
                  serviceUrl: this.config.serviceUrl,
                  renew: renew
                });
                _context4.next = 5;
                return fetch(endpoint, CASClient.createOptionsForPOST({
                  headers: _Object$assign({
                    'Content-Type': 'application/json'
                  }, this.config.enableOAuthMode && {
                    'X-OAuth-Flow-Mode': 'true'
                  }),
                  body: _JSON$stringify({
                    token: token
                  })
                }));

              case 5:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 8;
                  break;
                }

                throw new HTTPError(response);

              case 8:
                _context4.next = 10;
                return response.json();

              case 10:
                body = _context4.sent;

                if (!body.success) {
                  _context4.next = 13;
                  break;
                }

                return _context4.abrupt("return", {
                  success: true,
                  state: body
                });

              case 13:
                return _context4.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject(body)
                });

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject()
                });

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 16]]);
      }));

      function loginByToken(_x4) {
        return _loginByToken.apply(this, arguments);
      }

      return loginByToken;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _body$success, endpoint, response, body;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                endpoint = this.getEndpoint({
                  path: 'logout'
                });
                _context5.next = 4;
                return fetch(endpoint, CASClient.getRequestOptionsForGET());

              case 4:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context5.next = 9;
                return response.json();

              case 9:
                body = _context5.sent;
                return _context5.abrupt("return", {
                  success: (_body$success = body.success) !== null && _body$success !== void 0 ? _body$success : body.logoutSuccess
                });

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", {
                  success: false
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 13]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "imAlive",
    value: function () {
      var _imAlive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var endpoint, response, body;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                endpoint = this.getEndpoint({
                  path: 'imAlive'
                });
                _context6.next = 4;
                return fetch(endpoint, CASClient.getRequestOptionsForGET());

              case 4:
                response = _context6.sent;

                if (response.ok) {
                  _context6.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context6.next = 9;
                return response.json();

              case 9:
                body = _context6.sent;
                return _context6.abrupt("return", {
                  success: response.ok,
                  state: {
                    timeToKill: body.timeToKill,
                    expiresAt: body.expiresAt
                  }
                });

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](0);

                if (!(_context6.t0 instanceof HTTPError)) {
                  _context6.next = 17;
                  break;
                }

                throw _context6.t0;

              case 17:
                return _context6.abrupt("return", {
                  success: false,
                  state: {
                    timeToKill: -1,
                    expiresAt: -1
                  }
                });

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 13]]);
      }));

      function imAlive() {
        return _imAlive.apply(this, arguments);
      }

      return imAlive;
    }()
  }, {
    key: "getEndpoint",
    value: function getEndpoint(_ref3) {
      var path = _ref3.path,
          serviceUrl = _ref3.serviceUrl,
          gateway = _ref3.gateway,
          custLogin = _ref3.custLogin,
          renew = _ref3.renew;
      var useFeatureFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var version = '';

      if (useFeatureFlags) {
        if (this.config.enableRecaptcha) {
          version = '/v3';
        } else if (this.config.enableFlagHandling) {
          version = '/v2';
        }
      }

      var params = [serviceUrl ? "service=".concat(encodeURIComponent(serviceUrl)) : null, gateway ? 'gateway=true' : null, custLogin ? 'cust_login=true' : null, renew ? 'renew=true' : null].filter(function (param) {
        return param !== null;
      }).join('&');
      var query = params ? "?".concat(params) : '';
      return "".concat(this.config.casUrl).concat(version, "/").concat(path).concat(query);
    }
  }], [{
    key: "createErrorObject",
    value: function createErrorObject() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var error = {
        code: '',
        message: '',
        placeholders: obj.placeholders
      };

      if (obj.failure) {
        error.code = obj.failure;
      } else if (obj.success === true) {
        error.code = 'error.authentication.already.logged.in';
      } else if (obj.success === false) {
        error.code = 'error.authentication.max.attempts';
      } else {
        error.code = 'error.authentication.general';
      }

      if (obj.flag || obj.token) {
        var _obj$flag, _obj$token;

        error.data = {
          flag: (_obj$flag = obj.flag) !== null && _obj$flag !== void 0 ? _obj$flag : null,
          token: (_obj$token = obj.token) !== null && _obj$token !== void 0 ? _obj$token : null
        };
      }

      return error;
    }
  }, {
    key: "getRequestOptionsForGET",
    value: function getRequestOptionsForGET() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          headers = _ref4.headers;

      return {
        method: 'GET',
        headers: _Object$assign({
          Accept: 'application/json'
        }, headers),
        credentials: 'include'
      };
    }
  }, {
    key: "createOptionsForPOST",
    value: function createOptionsForPOST() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          headers = _ref5.headers,
          body = _ref5.body;

      return {
        method: 'POST',
        headers: _Object$assign({
          Accept: 'application/json',
          'Accept-Language': 'ql'
        }, headers),
        body: body,
        credentials: 'include'
      };
    }
  }]);

  return CASClient;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9DQVNDbGllbnQudHMiXSwibmFtZXMiOlsiSFRUUEVycm9yIiwib2JqZWN0VG9RdWVyeVN0cmluZyIsImJvb2xlYW5Ub1N0cmluZyIsIkNBU0NsaWVudCIsImNvbmZpZyIsImNhc1VybCIsInJlcGxhY2UiLCJwYXJhbXMiLCJlbmRwb2ludCIsImdldEVuZHBvaW50IiwicGF0aCIsInNlcnZpY2VVcmwiLCJmZXRjaCIsImdldFJlcXVlc3RPcHRpb25zRm9yR0VUIiwicmVzcG9uc2UiLCJvayIsImpzb24iLCJib2R5Iiwic3VjY2VzcyIsInN0YXRlIiwiZXJyb3IiLCJjcmVhdGVFcnJvck9iamVjdCIsImZvcm1fZGVmYXVsdHMiLCJvYmoiLCJsb2dpbkV4ZWN1dGlvblBhcmFtcyIsImx0IiwiZXhlY3V0aW9uIiwiZXhlY3V0aW9uS2V5IiwiX2V2ZW50SWQiLCJ1c2VybmFtZSIsInJlbWVtYmVyVXNlcm5hbWUiLCJyZW1lbWJlck1lIiwia2VlcE1lTG9nZ2VkSW4iLCJwYXNzd29yZCIsInRva2VuIiwicmVuZXciLCJjcmVhdGVPcHRpb25zRm9yUE9TVCIsImhlYWRlcnMiLCJpc05hdGl2ZUFwcERldmljZSIsImVuYWJsZU9BdXRoTW9kZSIsIl9yZW1lbWJlclVzZXJuYW1lIiwiX3JlbWVtYmVyTWUiLCJsb2dvdXRTdWNjZXNzIiwidGltZVRvS2lsbCIsImV4cGlyZXNBdCIsImdhdGV3YXkiLCJjdXN0TG9naW4iLCJ1c2VGZWF0dXJlRmxhZ3MiLCJ2ZXJzaW9uIiwiZW5hYmxlUmVjYXB0Y2hhIiwiZW5hYmxlRmxhZ0hhbmRsaW5nIiwiZW5jb2RlVVJJQ29tcG9uZW50IiwiZmlsdGVyIiwicGFyYW0iLCJqb2luIiwicXVlcnkiLCJjb2RlIiwibWVzc2FnZSIsInBsYWNlaG9sZGVycyIsImZhaWx1cmUiLCJmbGFnIiwiZGF0YSIsIm1ldGhvZCIsIkFjY2VwdCIsImNyZWRlbnRpYWxzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsU0FBU0EsU0FBVCxFQUFvQkMsbUJBQXBCLEVBQXlDQyxlQUF6QyxRQUFnRSxRQUFoRTtBQWdCQSxXQUFhQyxTQUFiO0FBSUUscUJBQVlDLE1BQVosRUFBcUM7QUFBQTs7QUFBQTs7QUFBQTs7QUFDbkMsU0FBS0EsTUFBTCxzQkFDS0EsTUFETDtBQUVFQyxNQUFBQSxNQUFNLEVBQUVELE1BQU0sQ0FBQ0MsTUFBUCxDQUFjQyxPQUFkLENBQXNCLE1BQXRCLEVBQThCLEVBQTlCO0FBRlY7QUFJRDs7QUFUSDtBQUFBO0FBQUE7QUFBQSw0RkFXb0JDLE1BWHBCO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBYVlDLGdCQUFBQSxRQWJaLEdBYXVCLEtBQUtDLFdBQUw7QUFBbUJDLGtCQUFBQSxJQUFJLEVBQUUsT0FBekI7QUFBa0NDLGtCQUFBQSxVQUFVLEVBQUUsS0FBS1AsTUFBTCxDQUFZTztBQUExRCxtQkFBeUVKLE1BQXpFLEVBYnZCO0FBQUE7QUFBQSx1QkFjNkJLLEtBQUssQ0FBQ0osUUFBRCxFQUFXTCxTQUFTLENBQUNVLHVCQUFWLEVBQVgsQ0FkbEM7O0FBQUE7QUFjWUMsZ0JBQUFBLFFBZFo7O0FBQUEsb0JBZ0JXQSxRQUFRLENBQUNDLEVBaEJwQjtBQUFBO0FBQUE7QUFBQTs7QUFBQSxzQkFpQmMsSUFBSWYsU0FBSixDQUFjYyxRQUFkLENBakJkOztBQUFBO0FBQUE7QUFBQSx1QkFvQnlCQSxRQUFRLENBQUNFLElBQVQsRUFwQnpCOztBQUFBO0FBb0JZQyxnQkFBQUEsSUFwQlo7O0FBQUEscUJBc0JVQSxJQUFJLENBQUNDLE9BdEJmO0FBQUE7QUFBQTtBQUFBOztBQUFBLGlEQXVCZTtBQUNMQSxrQkFBQUEsT0FBTyxFQUFFLElBREo7QUFFTEMsa0JBQUFBLEtBQUssRUFBRUY7QUFGRixpQkF2QmY7O0FBQUE7QUFBQSxpREE2QmE7QUFDTEMsa0JBQUFBLE9BQU8sRUFBRSxLQURKO0FBRUxFLGtCQUFBQSxLQUFLLEVBQUVqQixTQUFTLENBQUNrQixpQkFBVixDQUE0QkosSUFBNUI7QUFGRixpQkE3QmI7O0FBQUE7QUFBQTtBQUFBO0FBQUEsaURBa0NhO0FBQ0xDLGtCQUFBQSxPQUFPLEVBQUUsS0FESjtBQUVMRSxrQkFBQUEsS0FBSyxFQUFFakIsU0FBUyxDQUFDa0IsaUJBQVY7QUFGRixpQkFsQ2I7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSx1R0F5QzhCZCxNQXpDOUI7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBMkNZQyxnQkFBQUEsUUEzQ1osR0EyQ3VCLEtBQUtDLFdBQUw7QUFBbUJDLGtCQUFBQSxJQUFJLEVBQUUsT0FBekI7QUFBa0NDLGtCQUFBQSxVQUFVLEVBQUUsS0FBS1AsTUFBTCxDQUFZTztBQUExRCxtQkFBeUVKLE1BQXpFLEdBQW1GLElBQW5GLENBM0N2QjtBQUFBO0FBQUEsdUJBNEM2QkssS0FBSyxDQUFDSixRQUFELEVBQVdMLFNBQVMsQ0FBQ1UsdUJBQVYsRUFBWCxDQTVDbEM7O0FBQUE7QUE0Q1lDLGdCQUFBQSxRQTVDWjs7QUFBQSxvQkE4Q1dBLFFBQVEsQ0FBQ0MsRUE5Q3BCO0FBQUE7QUFBQTtBQUFBOztBQUFBLHNCQStDYyxJQUFJZixTQUFKLENBQWNjLFFBQWQsQ0EvQ2Q7O0FBQUE7QUFBQTtBQUFBLHVCQWtEeUJBLFFBQVEsQ0FBQ0UsSUFBVCxFQWxEekI7O0FBQUE7QUFrRFlDLGdCQUFBQSxJQWxEWjs7QUFBQSxxQkFvRFVBLElBQUksQ0FBQ0ssYUFwRGY7QUFBQTtBQUFBO0FBQUE7O0FBcUQrQkMsZ0JBQUFBLEdBckQvQixHQXFEdUNOLElBckR2QyxDQXFEZ0JLLGFBckRoQjtBQXVEUSxxQkFBS0Usb0JBQUwsR0FBNEI7QUFDMUJDLGtCQUFBQSxFQUFFLEVBQUVGLEdBQUcsQ0FBQ0UsRUFEa0I7QUFFMUJDLGtCQUFBQSxTQUFTLEVBQUVILEdBQUcsQ0FBQ0ksWUFGVztBQUcxQkMsa0JBQUFBLFFBQVEsRUFBRUwsR0FBRyxDQUFDSztBQUhZLGlCQUE1QjtBQXZEUixrREE2RGU7QUFDTFYsa0JBQUFBLE9BQU8sRUFBRSxJQURKO0FBRUxDLGtCQUFBQSxLQUFLLEVBQUU7QUFDTFUsb0JBQUFBLFFBQVEsbUJBQUVOLEdBQUcsQ0FBQ00sUUFBTix5REFBa0IsRUFEckI7QUFFTEMsb0JBQUFBLGdCQUFnQixFQUFFLENBQUMsQ0FBQ1AsR0FBRyxDQUFDTyxnQkFGbkI7QUFHTEMsb0JBQUFBLFVBQVUsRUFBRSxDQUFDLENBQUNSLEdBQUcsQ0FBQ1M7QUFIYjtBQUZGLGlCQTdEZjs7QUFBQTtBQUFBLGtEQXVFYTtBQUNMZCxrQkFBQUEsT0FBTyxFQUFFLEtBREo7QUFFTEUsa0JBQUFBLEtBQUssRUFBRWpCLFNBQVMsQ0FBQ2tCLGlCQUFWLENBQTRCSixJQUE1QjtBQUZGLGlCQXZFYjs7QUFBQTtBQUFBO0FBQUE7QUFBQSxrREE0RWE7QUFDTEMsa0JBQUFBLE9BQU8sRUFBRSxLQURKO0FBRUxFLGtCQUFBQSxLQUFLLEVBQUVqQixTQUFTLENBQUNrQixpQkFBVjtBQUZGLGlCQTVFYjs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQW9GSVEsZ0JBQUFBLFFBcEZKLFFBb0ZJQSxRQXBGSixFQXFGSUksUUFyRkosUUFxRklBLFFBckZKLEVBc0ZJRixVQXRGSixRQXNGSUEsVUF0RkosRUF1RklELGdCQXZGSixRQXVGSUEsZ0JBdkZKLEVBd0ZJSSxLQXhGSixRQXdGSUEsS0F4RkosRUF5RklDLEtBekZKLFFBeUZJQSxLQXpGSjtBQUFBO0FBNEZZM0IsZ0JBQUFBLFFBNUZaLEdBNEZ1QixLQUFLQyxXQUFMLENBQWlCO0FBQUVDLGtCQUFBQSxJQUFJLEVBQUUsT0FBUjtBQUFpQkMsa0JBQUFBLFVBQVUsRUFBRSxLQUFLUCxNQUFMLENBQVlPLFVBQXpDO0FBQXFEd0Isa0JBQUFBLEtBQUssRUFBTEE7QUFBckQsaUJBQWpCLEVBQStFLElBQS9FLENBNUZ2QjtBQUFBO0FBQUEsdUJBNkY2QnZCLEtBQUssQ0FDMUJKLFFBRDBCLEVBRTFCTCxTQUFTLENBQUNpQyxvQkFBVixDQUErQjtBQUM3QkMsa0JBQUFBLE9BQU87QUFDTCxvQ0FBZ0I7QUFEWCxxQkFFREgsS0FBSyxJQUFJO0FBQUUsdUNBQW1CQTtBQUFyQixtQkFGUixFQUdELEtBQUs5QixNQUFMLENBQVlrQyxpQkFBWixJQUFpQztBQUFFLHVDQUFtQjtBQUFyQixtQkFIaEMsRUFJRCxLQUFLbEMsTUFBTCxDQUFZbUMsZUFBWixJQUErQjtBQUFFLHlDQUFxQjtBQUF2QixtQkFKOUIsQ0FEc0I7QUFPN0J0QixrQkFBQUEsSUFBSSxFQUFFaEIsbUJBQW1CO0FBQ3ZCNEIsb0JBQUFBLFFBQVEsRUFBUkEsUUFEdUI7QUFFdkJJLG9CQUFBQSxRQUFRLEVBQVJBLFFBRnVCO0FBR3ZCRixvQkFBQUEsVUFBVSxFQUFWQSxVQUh1QjtBQUl2QkQsb0JBQUFBLGdCQUFnQixFQUFoQkEsZ0JBSnVCO0FBS3ZCVSxvQkFBQUEsaUJBQWlCLEVBQUV0QyxlQUFlLENBQUM0QixnQkFBRCxDQUxYO0FBTXZCVyxvQkFBQUEsV0FBVyxFQUFFdkMsZUFBZSxDQUFDNkIsVUFBRDtBQU5MLHFCQU9wQixLQUFLUCxvQkFQZTtBQVBJLGlCQUEvQixDQUYwQixDQTdGbEM7O0FBQUE7QUE2RllWLGdCQUFBQSxRQTdGWjs7QUFBQSxvQkFrSFdBLFFBQVEsQ0FBQ0MsRUFsSHBCO0FBQUE7QUFBQTtBQUFBOztBQUFBLHNCQW1IYyxJQUFJZixTQUFKLENBQWNjLFFBQWQsQ0FuSGQ7O0FBQUE7QUFBQTtBQUFBLHVCQXNIeUJBLFFBQVEsQ0FBQ0UsSUFBVCxFQXRIekI7O0FBQUE7QUFzSFlDLGdCQUFBQSxJQXRIWjs7QUFBQSxxQkF3SFVBLElBQUksQ0FBQ0MsT0F4SGY7QUFBQTtBQUFBO0FBQUE7O0FBQUEsa0RBeUhlO0FBQ0xBLGtCQUFBQSxPQUFPLEVBQUUsSUFESjtBQUVMQyxrQkFBQUEsS0FBSyxFQUFFRjtBQUZGLGlCQXpIZjs7QUFBQTtBQUFBLGtEQStIYTtBQUNMQyxrQkFBQUEsT0FBTyxFQUFFLEtBREo7QUFFTEUsa0JBQUFBLEtBQUssRUFBRWpCLFNBQVMsQ0FBQ2tCLGlCQUFWLENBQTRCSixJQUE1QjtBQUZGLGlCQS9IYjs7QUFBQTtBQUFBO0FBQUE7QUFBQSxrREFvSWE7QUFDTEMsa0JBQUFBLE9BQU8sRUFBRSxLQURKO0FBRUxFLGtCQUFBQSxLQUFLLEVBQUVqQixTQUFTLENBQUNrQixpQkFBVjtBQUZGLGlCQXBJYjs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQTJJOEJhLGdCQUFBQSxLQTNJOUIsU0EySThCQSxLQTNJOUIsRUEySXFDQyxLQTNJckMsU0EySXFDQSxLQTNJckM7QUFBQTtBQTZJWTNCLGdCQUFBQSxRQTdJWixHQTZJdUIsS0FBS0MsV0FBTCxDQUFpQjtBQUFFQyxrQkFBQUEsSUFBSSxFQUFFLFlBQVI7QUFBc0JDLGtCQUFBQSxVQUFVLEVBQUUsS0FBS1AsTUFBTCxDQUFZTyxVQUE5QztBQUEwRHdCLGtCQUFBQSxLQUFLLEVBQUxBO0FBQTFELGlCQUFqQixDQTdJdkI7QUFBQTtBQUFBLHVCQThJNkJ2QixLQUFLLENBQzFCSixRQUQwQixFQUUxQkwsU0FBUyxDQUFDaUMsb0JBQVYsQ0FBK0I7QUFDN0JDLGtCQUFBQSxPQUFPO0FBQ0wsb0NBQWdCO0FBRFgscUJBRUQsS0FBS2pDLE1BQUwsQ0FBWW1DLGVBQVosSUFBK0I7QUFBRSx5Q0FBcUI7QUFBdkIsbUJBRjlCLENBRHNCO0FBSzdCdEIsa0JBQUFBLElBQUksRUFBRSxnQkFBZTtBQUFFaUIsb0JBQUFBLEtBQUssRUFBTEE7QUFBRixtQkFBZjtBQUx1QixpQkFBL0IsQ0FGMEIsQ0E5SWxDOztBQUFBO0FBOElZcEIsZ0JBQUFBLFFBOUlaOztBQUFBLG9CQXlKV0EsUUFBUSxDQUFDQyxFQXpKcEI7QUFBQTtBQUFBO0FBQUE7O0FBQUEsc0JBMEpjLElBQUlmLFNBQUosQ0FBY2MsUUFBZCxDQTFKZDs7QUFBQTtBQUFBO0FBQUEsdUJBNkp5QkEsUUFBUSxDQUFDRSxJQUFULEVBN0p6Qjs7QUFBQTtBQTZKWUMsZ0JBQUFBLElBN0paOztBQUFBLHFCQStKVUEsSUFBSSxDQUFDQyxPQS9KZjtBQUFBO0FBQUE7QUFBQTs7QUFBQSxrREFnS2U7QUFDTEEsa0JBQUFBLE9BQU8sRUFBRSxJQURKO0FBRUxDLGtCQUFBQSxLQUFLLEVBQUVGO0FBRkYsaUJBaEtmOztBQUFBO0FBQUEsa0RBc0thO0FBQ0xDLGtCQUFBQSxPQUFPLEVBQUUsS0FESjtBQUVMRSxrQkFBQUEsS0FBSyxFQUFFakIsU0FBUyxDQUFDa0IsaUJBQVYsQ0FBNEJKLElBQTVCO0FBRkYsaUJBdEtiOztBQUFBO0FBQUE7QUFBQTtBQUFBLGtEQTJLYTtBQUNMQyxrQkFBQUEsT0FBTyxFQUFFLEtBREo7QUFFTEUsa0JBQUFBLEtBQUssRUFBRWpCLFNBQVMsQ0FBQ2tCLGlCQUFWO0FBRkYsaUJBM0tiOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBb0xZYixnQkFBQUEsUUFwTFosR0FvTHVCLEtBQUtDLFdBQUwsQ0FBaUI7QUFBRUMsa0JBQUFBLElBQUksRUFBRTtBQUFSLGlCQUFqQixDQXBMdkI7QUFBQTtBQUFBLHVCQXFMNkJFLEtBQUssQ0FBQ0osUUFBRCxFQUFXTCxTQUFTLENBQUNVLHVCQUFWLEVBQVgsQ0FyTGxDOztBQUFBO0FBcUxZQyxnQkFBQUEsUUFyTFo7O0FBQUEsb0JBdUxXQSxRQUFRLENBQUNDLEVBdkxwQjtBQUFBO0FBQUE7QUFBQTs7QUFBQSxzQkF3TGMsSUFBSWYsU0FBSixDQUFjYyxRQUFkLENBeExkOztBQUFBO0FBQUE7QUFBQSx1QkEyTHlCQSxRQUFRLENBQUNFLElBQVQsRUEzTHpCOztBQUFBO0FBMkxZQyxnQkFBQUEsSUEzTFo7QUFBQSxrREE2TGE7QUFDTEMsa0JBQUFBLE9BQU8sbUJBQUVELElBQUksQ0FBQ0MsT0FBUCx5REFBa0JELElBQUksQ0FBQ3lCO0FBRHpCLGlCQTdMYjs7QUFBQTtBQUFBO0FBQUE7QUFBQSxrREFpTWE7QUFDTHhCLGtCQUFBQSxPQUFPLEVBQUU7QUFESixpQkFqTWI7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQXlNWVYsZ0JBQUFBLFFBek1aLEdBeU11QixLQUFLQyxXQUFMLENBQWlCO0FBQUVDLGtCQUFBQSxJQUFJLEVBQUU7QUFBUixpQkFBakIsQ0F6TXZCO0FBQUE7QUFBQSx1QkEwTTZCRSxLQUFLLENBQUNKLFFBQUQsRUFBV0wsU0FBUyxDQUFDVSx1QkFBVixFQUFYLENBMU1sQzs7QUFBQTtBQTBNWUMsZ0JBQUFBLFFBMU1aOztBQUFBLG9CQTRNV0EsUUFBUSxDQUFDQyxFQTVNcEI7QUFBQTtBQUFBO0FBQUE7O0FBQUEsc0JBNk1jLElBQUlmLFNBQUosQ0FBY2MsUUFBZCxDQTdNZDs7QUFBQTtBQUFBO0FBQUEsdUJBZ055QkEsUUFBUSxDQUFDRSxJQUFULEVBaE56Qjs7QUFBQTtBQWdOWUMsZ0JBQUFBLElBaE5aO0FBQUEsa0RBa05hO0FBQ0xDLGtCQUFBQSxPQUFPLEVBQUVKLFFBQVEsQ0FBQ0MsRUFEYjtBQUVMSSxrQkFBQUEsS0FBSyxFQUFFO0FBQ0x3QixvQkFBQUEsVUFBVSxFQUFFMUIsSUFBSSxDQUFDMEIsVUFEWjtBQUVMQyxvQkFBQUEsU0FBUyxFQUFFM0IsSUFBSSxDQUFDMkI7QUFGWDtBQUZGLGlCQWxOYjs7QUFBQTtBQUFBO0FBQUE7O0FBQUEsc0JBME5VLHdCQUFpQjVDLFNBMU4zQjtBQUFBO0FBQUE7QUFBQTs7QUFBQTs7QUFBQTtBQUFBLGtEQThOYTtBQUNMa0Isa0JBQUFBLE9BQU8sRUFBRSxLQURKO0FBRUxDLGtCQUFBQSxLQUFLLEVBQUU7QUFDTHdCLG9CQUFBQSxVQUFVLEVBQUUsQ0FBQyxDQURSO0FBRUxDLG9CQUFBQSxTQUFTLEVBQUUsQ0FBQztBQUZQO0FBRkYsaUJBOU5iOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLHVDQTRPSTtBQUFBLFVBSEVsQyxJQUdGLFNBSEVBLElBR0Y7QUFBQSxVQUhRQyxVQUdSLFNBSFFBLFVBR1I7QUFBQSxVQUhvQmtDLE9BR3BCLFNBSG9CQSxPQUdwQjtBQUFBLFVBSDZCQyxTQUc3QixTQUg2QkEsU0FHN0I7QUFBQSxVQUh3Q1gsS0FHeEMsU0FId0NBLEtBR3hDO0FBQUEsVUFEQVksZUFDQSx1RUFEMkIsS0FDM0I7QUFDQSxVQUFJQyxPQUFPLEdBQUcsRUFBZDs7QUFFQSxVQUFJRCxlQUFKLEVBQXFCO0FBQ25CLFlBQUksS0FBSzNDLE1BQUwsQ0FBWTZDLGVBQWhCLEVBQWlDO0FBQy9CRCxVQUFBQSxPQUFPLEdBQUcsS0FBVjtBQUNELFNBRkQsTUFFTyxJQUFJLEtBQUs1QyxNQUFMLENBQVk4QyxrQkFBaEIsRUFBb0M7QUFDekNGLFVBQUFBLE9BQU8sR0FBRyxLQUFWO0FBQ0Q7QUFDRjs7QUFFRCxVQUFNekMsTUFBTSxHQUFHLENBQ2JJLFVBQVUscUJBQWN3QyxrQkFBa0IsQ0FBQ3hDLFVBQUQsQ0FBaEMsSUFBaUQsSUFEOUMsRUFFYmtDLE9BQU8sR0FBRyxjQUFILEdBQW9CLElBRmQsRUFHYkMsU0FBUyxHQUFHLGlCQUFILEdBQXVCLElBSG5CLEVBSWJYLEtBQUssR0FBRyxZQUFILEdBQWtCLElBSlYsRUFNWmlCLE1BTlksQ0FNTCxVQUFDQyxLQUFEO0FBQUEsZUFBV0EsS0FBSyxLQUFLLElBQXJCO0FBQUEsT0FOSyxFQU9aQyxJQVBZLENBT1AsR0FQTyxDQUFmO0FBUUEsVUFBTUMsS0FBSyxHQUFHaEQsTUFBTSxjQUFPQSxNQUFQLElBQWtCLEVBQXRDO0FBRUEsdUJBQVUsS0FBS0gsTUFBTCxDQUFZQyxNQUF0QixTQUErQjJDLE9BQS9CLGNBQTBDdEMsSUFBMUMsU0FBaUQ2QyxLQUFqRDtBQUNEO0FBbFFIO0FBQUE7QUFBQSx3Q0E0UTJCO0FBQUEsVUFQdkJoQyxHQU91Qix1RUFEbkIsRUFDbUI7QUFDdkIsVUFBTUgsS0FBNEIsR0FBRztBQUFFb0MsUUFBQUEsSUFBSSxFQUFFLEVBQVI7QUFBWUMsUUFBQUEsT0FBTyxFQUFFLEVBQXJCO0FBQXlCQyxRQUFBQSxZQUFZLEVBQUVuQyxHQUFHLENBQUNtQztBQUEzQyxPQUFyQzs7QUFFQSxVQUFJbkMsR0FBRyxDQUFDb0MsT0FBUixFQUFpQjtBQUNmdkMsUUFBQUEsS0FBSyxDQUFDb0MsSUFBTixHQUFhakMsR0FBRyxDQUFDb0MsT0FBakI7QUFDRCxPQUZELE1BRU8sSUFBSXBDLEdBQUcsQ0FBQ0wsT0FBSixLQUFnQixJQUFwQixFQUEwQjtBQUMvQkUsUUFBQUEsS0FBSyxDQUFDb0MsSUFBTixHQUFhLHdDQUFiO0FBQ0QsT0FGTSxNQUVBLElBQUlqQyxHQUFHLENBQUNMLE9BQUosS0FBZ0IsS0FBcEIsRUFBMkI7QUFDaENFLFFBQUFBLEtBQUssQ0FBQ29DLElBQU4sR0FBYSxtQ0FBYjtBQUNELE9BRk0sTUFFQTtBQUNMcEMsUUFBQUEsS0FBSyxDQUFDb0MsSUFBTixHQUFhLDhCQUFiO0FBQ0Q7O0FBRUQsVUFBSWpDLEdBQUcsQ0FBQ3FDLElBQUosSUFBWXJDLEdBQUcsQ0FBQ1csS0FBcEIsRUFBMkI7QUFBQTs7QUFDekJkLFFBQUFBLEtBQUssQ0FBQ3lDLElBQU4sR0FBYTtBQUFFRCxVQUFBQSxJQUFJLGVBQUVyQyxHQUFHLENBQUNxQyxJQUFOLGlEQUFjLElBQXBCO0FBQTBCMUIsVUFBQUEsS0FBSyxnQkFBRVgsR0FBRyxDQUFDVyxLQUFOLG1EQUFlO0FBQTlDLFNBQWI7QUFDRDs7QUFFRCxhQUFPZCxLQUFQO0FBQ0Q7QUE5Ukg7QUFBQTtBQUFBLDhDQWdTbUc7QUFBQSxzRkFBakIsRUFBaUI7QUFBQSxVQUF4RGlCLE9BQXdELFNBQXhEQSxPQUF3RDs7QUFDL0YsYUFBTztBQUNMeUIsUUFBQUEsTUFBTSxFQUFFLEtBREg7QUFFTHpCLFFBQUFBLE9BQU87QUFDTDBCLFVBQUFBLE1BQU0sRUFBRTtBQURILFdBRUYxQixPQUZFLENBRkY7QUFNTDJCLFFBQUFBLFdBQVcsRUFBRTtBQU5SLE9BQVA7QUFRRDtBQXpTSDtBQUFBO0FBQUEsMkNBMlN1SDtBQUFBLHNGQUFqQixFQUFpQjtBQUFBLFVBQS9FM0IsT0FBK0UsU0FBL0VBLE9BQStFO0FBQUEsVUFBdEVwQixJQUFzRSxTQUF0RUEsSUFBc0U7O0FBQ25ILGFBQU87QUFDTDZDLFFBQUFBLE1BQU0sRUFBRSxNQURIO0FBRUx6QixRQUFBQSxPQUFPO0FBQ0wwQixVQUFBQSxNQUFNLEVBQUUsa0JBREg7QUFFTCw2QkFBbUI7QUFGZCxXQUdGMUIsT0FIRSxDQUZGO0FBT0xwQixRQUFBQSxJQUFJLEVBQUpBLElBUEs7QUFRTCtDLFFBQUFBLFdBQVcsRUFBRTtBQVJSLE9BQVA7QUFVRDtBQXRUSDs7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgSFRUUEVycm9yLCBvYmplY3RUb1F1ZXJ5U3RyaW5nLCBib29sZWFuVG9TdHJpbmcgfSBmcm9tICcuL2xpYnMnO1xuaW1wb3J0IHR5cGUge1xuICBDQVNDbGllbnRDb25maWcsXG4gIENBU0NsaWVudEVuZHBvaW50QXJncyxcbiAgQ0FTQ2xpZW50R2V0TG9naW5QYXJhbXNBcmdzLFxuICBDQVNDbGllbnRHZXRMb2dpblBhcmFtc1Jlc3BvbnNlLFxuICBDQVNDbGllbnRJbUFsaXZlUmVzcG9uc2UsXG4gIENBU0NsaWVudEluaXRBcmdzLFxuICBDQVNDbGllbnRMb2dpbkFyZ3MsXG4gIENBU0NsaWVudExvZ2luRXhlY3V0aW9uUGFyYW1zLFxuICBDQVNDbGllbnRMb2dpblJlc3BvbnNlLFxuICBDQVNDbGllbnRMb2dvdXRSZXNwb25zZSxcbiAgQ0FTQ2xpZW50UmVzb25zZUVycm9yLFxuICBDQVNDbGllbnRUb2tlbkxvZ2luUGFyYW1zLFxufSBmcm9tICcuL3R5cGVzJztcblxuZXhwb3J0IGNsYXNzIENBU0NsaWVudCB7XG4gIHByaXZhdGUgcmVhZG9ubHkgY29uZmlnOiBDQVNDbGllbnRDb25maWc7XG4gIHByaXZhdGUgbG9naW5FeGVjdXRpb25QYXJhbXM6IENBU0NsaWVudExvZ2luRXhlY3V0aW9uUGFyYW1zIHwgdW5kZWZpbmVkO1xuXG4gIGNvbnN0cnVjdG9yKGNvbmZpZzogQ0FTQ2xpZW50Q29uZmlnKSB7XG4gICAgdGhpcy5jb25maWcgPSB7XG4gICAgICAuLi5jb25maWcsXG4gICAgICBjYXNVcmw6IGNvbmZpZy5jYXNVcmwucmVwbGFjZSgvXFwvKyQvLCAnJyksXG4gICAgfTtcbiAgfVxuXG4gIHB1YmxpYyBhc3luYyBpbml0KHBhcmFtcz86IENBU0NsaWVudEluaXRBcmdzKTogUHJvbWlzZTxDQVNDbGllbnRMb2dpblJlc3BvbnNlPiB7XG4gICAgdHJ5IHtcbiAgICAgIGNvbnN0IGVuZHBvaW50ID0gdGhpcy5nZXRFbmRwb2ludCh7IHBhdGg6ICdsb2dpbicsIHNlcnZpY2VVcmw6IHRoaXMuY29uZmlnLnNlcnZpY2VVcmwsIC4uLnBhcmFtcyB9KTtcbiAgICAgIGNvbnN0IHJlc3BvbnNlID0gYXdhaXQgZmV0Y2goZW5kcG9pbnQsIENBU0NsaWVudC5nZXRSZXF1ZXN0T3B0aW9uc0ZvckdFVCgpKTtcblxuICAgICAgaWYgKCFyZXNwb25zZS5vaykge1xuICAgICAgICB0aHJvdyBuZXcgSFRUUEVycm9yKHJlc3BvbnNlKTtcbiAgICAgIH1cblxuICAgICAgY29uc3QgYm9keSA9IGF3YWl0IHJlc3BvbnNlLmpzb24oKTtcblxuICAgICAgaWYgKGJvZHkuc3VjY2Vzcykge1xuICAgICAgICByZXR1cm4ge1xuICAgICAgICAgIHN1Y2Nlc3M6IHRydWUsXG4gICAgICAgICAgc3RhdGU6IGJvZHksXG4gICAgICAgIH07XG4gICAgICB9XG5cbiAgICAgIHJldHVybiB7XG4gICAgICAgIHN1Y2Nlc3M6IGZhbHNlLFxuICAgICAgICBlcnJvcjogQ0FTQ2xpZW50LmNyZWF0ZUVycm9yT2JqZWN0KGJvZHkpLFxuICAgICAgfTtcbiAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgcmV0dXJuIHtcbiAgICAgICAgc3VjY2VzczogZmFsc2UsXG4gICAgICAgIGVycm9yOiBDQVNDbGllbnQuY3JlYXRlRXJyb3JPYmplY3QoKSxcbiAgICAgIH07XG4gICAgfVxuICB9XG5cbiAgcHVibGljIGFzeW5jIGdldExvZ2luUGFyYW1zKHBhcmFtcz86IENBU0NsaWVudEdldExvZ2luUGFyYW1zQXJncyk6IFByb21pc2U8Q0FTQ2xpZW50R2V0TG9naW5QYXJhbXNSZXNwb25zZT4ge1xuICAgIHRyeSB7XG4gICAgICBjb25zdCBlbmRwb2ludCA9IHRoaXMuZ2V0RW5kcG9pbnQoeyBwYXRoOiAnbG9naW4nLCBzZXJ2aWNlVXJsOiB0aGlzLmNvbmZpZy5zZXJ2aWNlVXJsLCAuLi5wYXJhbXMgfSwgdHJ1ZSk7XG4gICAgICBjb25zdCByZXNwb25zZSA9IGF3YWl0IGZldGNoKGVuZHBvaW50LCBDQVNDbGllbnQuZ2V0UmVxdWVzdE9wdGlvbnNGb3JHRVQoKSk7XG5cbiAgICAgIGlmICghcmVzcG9uc2Uub2spIHtcbiAgICAgICAgdGhyb3cgbmV3IEhUVFBFcnJvcihyZXNwb25zZSk7XG4gICAgICB9XG5cbiAgICAgIGNvbnN0IGJvZHkgPSBhd2FpdCByZXNwb25zZS5qc29uKCk7XG5cbiAgICAgIGlmIChib2R5LmZvcm1fZGVmYXVsdHMpIHtcbiAgICAgICAgY29uc3QgeyBmb3JtX2RlZmF1bHRzOiBvYmogfSA9IGJvZHk7XG5cbiAgICAgICAgdGhpcy5sb2dpbkV4ZWN1dGlvblBhcmFtcyA9IHtcbiAgICAgICAgICBsdDogb2JqLmx0LFxuICAgICAgICAgIGV4ZWN1dGlvbjogb2JqLmV4ZWN1dGlvbktleSxcbiAgICAgICAgICBfZXZlbnRJZDogb2JqLl9ldmVudElkLFxuICAgICAgICB9O1xuXG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgc3VjY2VzczogdHJ1ZSxcbiAgICAgICAgICBzdGF0ZToge1xuICAgICAgICAgICAgdXNlcm5hbWU6IG9iai51c2VybmFtZSA/PyAnJyxcbiAgICAgICAgICAgIHJlbWVtYmVyVXNlcm5hbWU6ICEhb2JqLnJlbWVtYmVyVXNlcm5hbWUsXG4gICAgICAgICAgICByZW1lbWJlck1lOiAhIW9iai5rZWVwTWVMb2dnZWRJbixcbiAgICAgICAgICB9LFxuICAgICAgICB9O1xuICAgICAgfVxuXG4gICAgICByZXR1cm4ge1xuICAgICAgICBzdWNjZXNzOiBmYWxzZSxcbiAgICAgICAgZXJyb3I6IENBU0NsaWVudC5jcmVhdGVFcnJvck9iamVjdChib2R5KSxcbiAgICAgIH07XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHN1Y2Nlc3M6IGZhbHNlLFxuICAgICAgICBlcnJvcjogQ0FTQ2xpZW50LmNyZWF0ZUVycm9yT2JqZWN0KCksXG4gICAgICB9O1xuICAgIH1cbiAgfVxuXG4gIHB1YmxpYyBhc3luYyBsb2dpbih7XG4gICAgdXNlcm5hbWUsXG4gICAgcGFzc3dvcmQsXG4gICAgcmVtZW1iZXJNZSxcbiAgICByZW1lbWJlclVzZXJuYW1lLFxuICAgIHRva2VuLFxuICAgIHJlbmV3LFxuICB9OiBDQVNDbGllbnRMb2dpbkFyZ3MpOiBQcm9taXNlPENBU0NsaWVudExvZ2luUmVzcG9uc2U+IHtcbiAgICB0cnkge1xuICAgICAgY29uc3QgZW5kcG9pbnQgPSB0aGlzLmdldEVuZHBvaW50KHsgcGF0aDogJ2xvZ2luJywgc2VydmljZVVybDogdGhpcy5jb25maWcuc2VydmljZVVybCwgcmVuZXcgfSwgdHJ1ZSk7XG4gICAgICBjb25zdCByZXNwb25zZSA9IGF3YWl0IGZldGNoKFxuICAgICAgICBlbmRwb2ludCxcbiAgICAgICAgQ0FTQ2xpZW50LmNyZWF0ZU9wdGlvbnNGb3JQT1NUKHtcbiAgICAgICAgICBoZWFkZXJzOiB7XG4gICAgICAgICAgICAnQ29udGVudC1UeXBlJzogJ2FwcGxpY2F0aW9uL3gtd3d3LWZvcm0tdXJsZW5jb2RlZCcsXG4gICAgICAgICAgICAuLi4odG9rZW4gJiYgeyAnWC1DYXB0Y2hhLVRva2VuJzogdG9rZW4gfSksXG4gICAgICAgICAgICAuLi4odGhpcy5jb25maWcuaXNOYXRpdmVBcHBEZXZpY2UgJiYgeyAnWC1XSC1OYXRpdmUtQXBwJzogJ3RydWUnIH0pLFxuICAgICAgICAgICAgLi4uKHRoaXMuY29uZmlnLmVuYWJsZU9BdXRoTW9kZSAmJiB7ICdYLU9BdXRoLUZsb3ctTW9kZSc6ICd0cnVlJyB9KSxcbiAgICAgICAgICB9LFxuICAgICAgICAgIGJvZHk6IG9iamVjdFRvUXVlcnlTdHJpbmcoe1xuICAgICAgICAgICAgdXNlcm5hbWUsXG4gICAgICAgICAgICBwYXNzd29yZCxcbiAgICAgICAgICAgIHJlbWVtYmVyTWUsXG4gICAgICAgICAgICByZW1lbWJlclVzZXJuYW1lLFxuICAgICAgICAgICAgX3JlbWVtYmVyVXNlcm5hbWU6IGJvb2xlYW5Ub1N0cmluZyhyZW1lbWJlclVzZXJuYW1lKSxcbiAgICAgICAgICAgIF9yZW1lbWJlck1lOiBib29sZWFuVG9TdHJpbmcocmVtZW1iZXJNZSksXG4gICAgICAgICAgICAuLi50aGlzLmxvZ2luRXhlY3V0aW9uUGFyYW1zLFxuICAgICAgICAgIH0pLFxuICAgICAgICB9KVxuICAgICAgKTtcblxuICAgICAgaWYgKCFyZXNwb25zZS5vaykge1xuICAgICAgICB0aHJvdyBuZXcgSFRUUEVycm9yKHJlc3BvbnNlKTtcbiAgICAgIH1cblxuICAgICAgY29uc3QgYm9keSA9IGF3YWl0IHJlc3BvbnNlLmpzb24oKTtcblxuICAgICAgaWYgKGJvZHkuc3VjY2Vzcykge1xuICAgICAgICByZXR1cm4ge1xuICAgICAgICAgIHN1Y2Nlc3M6IHRydWUsXG4gICAgICAgICAgc3RhdGU6IGJvZHksXG4gICAgICAgIH07XG4gICAgICB9XG5cbiAgICAgIHJldHVybiB7XG4gICAgICAgIHN1Y2Nlc3M6IGZhbHNlLFxuICAgICAgICBlcnJvcjogQ0FTQ2xpZW50LmNyZWF0ZUVycm9yT2JqZWN0KGJvZHkpLFxuICAgICAgfTtcbiAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgcmV0dXJuIHtcbiAgICAgICAgc3VjY2VzczogZmFsc2UsXG4gICAgICAgIGVycm9yOiBDQVNDbGllbnQuY3JlYXRlRXJyb3JPYmplY3QoKSxcbiAgICAgIH07XG4gICAgfVxuICB9XG5cbiAgcHVibGljIGFzeW5jIGxvZ2luQnlUb2tlbih7IHRva2VuLCByZW5ldyB9OiBDQVNDbGllbnRUb2tlbkxvZ2luUGFyYW1zKTogUHJvbWlzZTxDQVNDbGllbnRMb2dpblJlc3BvbnNlPiB7XG4gICAgdHJ5IHtcbiAgICAgIGNvbnN0IGVuZHBvaW50ID0gdGhpcy5nZXRFbmRwb2ludCh7IHBhdGg6ICd0b2tlbmxvZ2luJywgc2VydmljZVVybDogdGhpcy5jb25maWcuc2VydmljZVVybCwgcmVuZXcgfSk7XG4gICAgICBjb25zdCByZXNwb25zZSA9IGF3YWl0IGZldGNoKFxuICAgICAgICBlbmRwb2ludCxcbiAgICAgICAgQ0FTQ2xpZW50LmNyZWF0ZU9wdGlvbnNGb3JQT1NUKHtcbiAgICAgICAgICBoZWFkZXJzOiB7XG4gICAgICAgICAgICAnQ29udGVudC1UeXBlJzogJ2FwcGxpY2F0aW9uL2pzb24nLFxuICAgICAgICAgICAgLi4uKHRoaXMuY29uZmlnLmVuYWJsZU9BdXRoTW9kZSAmJiB7ICdYLU9BdXRoLUZsb3ctTW9kZSc6ICd0cnVlJyB9KSxcbiAgICAgICAgICB9LFxuICAgICAgICAgIGJvZHk6IEpTT04uc3RyaW5naWZ5KHsgdG9rZW4gfSksXG4gICAgICAgIH0pXG4gICAgICApO1xuXG4gICAgICBpZiAoIXJlc3BvbnNlLm9rKSB7XG4gICAgICAgIHRocm93IG5ldyBIVFRQRXJyb3IocmVzcG9uc2UpO1xuICAgICAgfVxuXG4gICAgICBjb25zdCBib2R5ID0gYXdhaXQgcmVzcG9uc2UuanNvbigpO1xuXG4gICAgICBpZiAoYm9keS5zdWNjZXNzKSB7XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgc3VjY2VzczogdHJ1ZSxcbiAgICAgICAgICBzdGF0ZTogYm9keSxcbiAgICAgICAgfTtcbiAgICAgIH1cblxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgc3VjY2VzczogZmFsc2UsXG4gICAgICAgIGVycm9yOiBDQVNDbGllbnQuY3JlYXRlRXJyb3JPYmplY3QoYm9keSksXG4gICAgICB9O1xuICAgIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgICByZXR1cm4ge1xuICAgICAgICBzdWNjZXNzOiBmYWxzZSxcbiAgICAgICAgZXJyb3I6IENBU0NsaWVudC5jcmVhdGVFcnJvck9iamVjdCgpLFxuICAgICAgfTtcbiAgICB9XG4gIH1cblxuICBwdWJsaWMgYXN5bmMgbG9nb3V0KCk6IFByb21pc2U8Q0FTQ2xpZW50TG9nb3V0UmVzcG9uc2U+IHtcbiAgICB0cnkge1xuICAgICAgY29uc3QgZW5kcG9pbnQgPSB0aGlzLmdldEVuZHBvaW50KHsgcGF0aDogJ2xvZ291dCcgfSk7XG4gICAgICBjb25zdCByZXNwb25zZSA9IGF3YWl0IGZldGNoKGVuZHBvaW50LCBDQVNDbGllbnQuZ2V0UmVxdWVzdE9wdGlvbnNGb3JHRVQoKSk7XG5cbiAgICAgIGlmICghcmVzcG9uc2Uub2spIHtcbiAgICAgICAgdGhyb3cgbmV3IEhUVFBFcnJvcihyZXNwb25zZSk7XG4gICAgICB9XG5cbiAgICAgIGNvbnN0IGJvZHkgPSBhd2FpdCByZXNwb25zZS5qc29uKCk7XG5cbiAgICAgIHJldHVybiB7XG4gICAgICAgIHN1Y2Nlc3M6IGJvZHkuc3VjY2VzcyA/PyBib2R5LmxvZ291dFN1Y2Nlc3MsXG4gICAgICB9O1xuICAgIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgICByZXR1cm4ge1xuICAgICAgICBzdWNjZXNzOiBmYWxzZSxcbiAgICAgIH07XG4gICAgfVxuICB9XG5cbiAgcHVibGljIGFzeW5jIGltQWxpdmUoKTogUHJvbWlzZTxDQVNDbGllbnRJbUFsaXZlUmVzcG9uc2U+IHtcbiAgICB0cnkge1xuICAgICAgY29uc3QgZW5kcG9pbnQgPSB0aGlzLmdldEVuZHBvaW50KHsgcGF0aDogJ2ltQWxpdmUnIH0pO1xuICAgICAgY29uc3QgcmVzcG9uc2UgPSBhd2FpdCBmZXRjaChlbmRwb2ludCwgQ0FTQ2xpZW50LmdldFJlcXVlc3RPcHRpb25zRm9yR0VUKCkpO1xuXG4gICAgICBpZiAoIXJlc3BvbnNlLm9rKSB7XG4gICAgICAgIHRocm93IG5ldyBIVFRQRXJyb3IocmVzcG9uc2UpO1xuICAgICAgfVxuXG4gICAgICBjb25zdCBib2R5ID0gYXdhaXQgcmVzcG9uc2UuanNvbigpO1xuXG4gICAgICByZXR1cm4ge1xuICAgICAgICBzdWNjZXNzOiByZXNwb25zZS5vayxcbiAgICAgICAgc3RhdGU6IHtcbiAgICAgICAgICB0aW1lVG9LaWxsOiBib2R5LnRpbWVUb0tpbGwsXG4gICAgICAgICAgZXhwaXJlc0F0OiBib2R5LmV4cGlyZXNBdCxcbiAgICAgICAgfSxcbiAgICAgIH07XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgIGlmIChlcnJvciBpbnN0YW5jZW9mIEhUVFBFcnJvcikge1xuICAgICAgICB0aHJvdyBlcnJvcjtcbiAgICAgIH1cblxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgc3VjY2VzczogZmFsc2UsXG4gICAgICAgIHN0YXRlOiB7XG4gICAgICAgICAgdGltZVRvS2lsbDogLTEsXG4gICAgICAgICAgZXhwaXJlc0F0OiAtMSxcbiAgICAgICAgfSxcbiAgICAgIH07XG4gICAgfVxuICB9XG5cbiAgcHJpdmF0ZSBnZXRFbmRwb2ludChcbiAgICB7IHBhdGgsIHNlcnZpY2VVcmwsIGdhdGV3YXksIGN1c3RMb2dpbiwgcmVuZXcgfTogQ0FTQ2xpZW50RW5kcG9pbnRBcmdzLFxuICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBAdHlwZXNjcmlwdC1lc2xpbnQvbm8taW5mZXJyYWJsZS10eXBlc1xuICAgIHVzZUZlYXR1cmVGbGFnczogYm9vbGVhbiA9IGZhbHNlXG4gICkge1xuICAgIGxldCB2ZXJzaW9uID0gJyc7XG5cbiAgICBpZiAodXNlRmVhdHVyZUZsYWdzKSB7XG4gICAgICBpZiAodGhpcy5jb25maWcuZW5hYmxlUmVjYXB0Y2hhKSB7XG4gICAgICAgIHZlcnNpb24gPSAnL3YzJztcbiAgICAgIH0gZWxzZSBpZiAodGhpcy5jb25maWcuZW5hYmxlRmxhZ0hhbmRsaW5nKSB7XG4gICAgICAgIHZlcnNpb24gPSAnL3YyJztcbiAgICAgIH1cbiAgICB9XG5cbiAgICBjb25zdCBwYXJhbXMgPSBbXG4gICAgICBzZXJ2aWNlVXJsID8gYHNlcnZpY2U9JHtlbmNvZGVVUklDb21wb25lbnQoc2VydmljZVVybCl9YCA6IG51bGwsXG4gICAgICBnYXRld2F5ID8gJ2dhdGV3YXk9dHJ1ZScgOiBudWxsLFxuICAgICAgY3VzdExvZ2luID8gJ2N1c3RfbG9naW49dHJ1ZScgOiBudWxsLFxuICAgICAgcmVuZXcgPyAncmVuZXc9dHJ1ZScgOiBudWxsLFxuICAgIF1cbiAgICAgIC5maWx0ZXIoKHBhcmFtKSA9PiBwYXJhbSAhPT0gbnVsbClcbiAgICAgIC5qb2luKCcmJyk7XG4gICAgY29uc3QgcXVlcnkgPSBwYXJhbXMgPyBgPyR7cGFyYW1zfWAgOiAnJztcblxuICAgIHJldHVybiBgJHt0aGlzLmNvbmZpZy5jYXNVcmx9JHt2ZXJzaW9ufS8ke3BhdGh9JHtxdWVyeX1gO1xuICB9XG5cbiAgcHJpdmF0ZSBzdGF0aWMgY3JlYXRlRXJyb3JPYmplY3QoXG4gICAgb2JqOiB7XG4gICAgICBzdWNjZXNzPzogYm9vbGVhbjtcbiAgICAgIHBsYWNlaG9sZGVycz86IG9iamVjdDtcbiAgICAgIGZhaWx1cmU/OiBzdHJpbmc7XG4gICAgICBmbGFnPzogc3RyaW5nO1xuICAgICAgdG9rZW4/OiBzdHJpbmc7XG4gICAgfSA9IHt9XG4gICk6IENBU0NsaWVudFJlc29uc2VFcnJvciB7XG4gICAgY29uc3QgZXJyb3I6IENBU0NsaWVudFJlc29uc2VFcnJvciA9IHsgY29kZTogJycsIG1lc3NhZ2U6ICcnLCBwbGFjZWhvbGRlcnM6IG9iai5wbGFjZWhvbGRlcnMgfTtcblxuICAgIGlmIChvYmouZmFpbHVyZSkge1xuICAgICAgZXJyb3IuY29kZSA9IG9iai5mYWlsdXJlO1xuICAgIH0gZWxzZSBpZiAob2JqLnN1Y2Nlc3MgPT09IHRydWUpIHtcbiAgICAgIGVycm9yLmNvZGUgPSAnZXJyb3IuYXV0aGVudGljYXRpb24uYWxyZWFkeS5sb2dnZWQuaW4nO1xuICAgIH0gZWxzZSBpZiAob2JqLnN1Y2Nlc3MgPT09IGZhbHNlKSB7XG4gICAgICBlcnJvci5jb2RlID0gJ2Vycm9yLmF1dGhlbnRpY2F0aW9uLm1heC5hdHRlbXB0cyc7XG4gICAgfSBlbHNlIHtcbiAgICAgIGVycm9yLmNvZGUgPSAnZXJyb3IuYXV0aGVudGljYXRpb24uZ2VuZXJhbCc7XG4gICAgfVxuXG4gICAgaWYgKG9iai5mbGFnIHx8IG9iai50b2tlbikge1xuICAgICAgZXJyb3IuZGF0YSA9IHsgZmxhZzogb2JqLmZsYWcgPz8gbnVsbCwgdG9rZW46IG9iai50b2tlbiA/PyBudWxsIH07XG4gICAgfVxuXG4gICAgcmV0dXJuIGVycm9yO1xuICB9XG5cbiAgcHJpdmF0ZSBzdGF0aWMgZ2V0UmVxdWVzdE9wdGlvbnNGb3JHRVQoeyBoZWFkZXJzIH06IHsgaGVhZGVycz86IEhlYWRlcnNJbml0IH0gPSB7fSk6IFJlcXVlc3RJbml0IHtcbiAgICByZXR1cm4ge1xuICAgICAgbWV0aG9kOiAnR0VUJyxcbiAgICAgIGhlYWRlcnM6IHtcbiAgICAgICAgQWNjZXB0OiAnYXBwbGljYXRpb24vanNvbicsXG4gICAgICAgIC4uLmhlYWRlcnMsXG4gICAgICB9LFxuICAgICAgY3JlZGVudGlhbHM6ICdpbmNsdWRlJyxcbiAgICB9O1xuICB9XG5cbiAgcHJpdmF0ZSBzdGF0aWMgY3JlYXRlT3B0aW9uc0ZvclBPU1QoeyBoZWFkZXJzLCBib2R5IH06IHsgYm9keT86IEJvZHlJbml0OyBoZWFkZXJzPzogSGVhZGVyc0luaXQgfSA9IHt9KTogUmVxdWVzdEluaXQge1xuICAgIHJldHVybiB7XG4gICAgICBtZXRob2Q6ICdQT1NUJyxcbiAgICAgIGhlYWRlcnM6IHtcbiAgICAgICAgQWNjZXB0OiAnYXBwbGljYXRpb24vanNvbicsXG4gICAgICAgICdBY2NlcHQtTGFuZ3VhZ2UnOiAncWwnLFxuICAgICAgICAuLi5oZWFkZXJzLFxuICAgICAgfSxcbiAgICAgIGJvZHksXG4gICAgICBjcmVkZW50aWFsczogJ2luY2x1ZGUnLFxuICAgIH07XG4gIH1cbn1cbiJdfQ==